import CommitteesContent from './CommitteesContent';

export default CommitteesContent;
